<!--<div class="back-button-icon-wrapper" (click)="goBack()">-->
<!--  -->
<!--  <ui-icon icon="griddy-chevron-left" class="clickable" [size]="24"></ui-icon>-->
<!--</div>-->
<ui-button variant="tertiary" icon="griddy-chevron-left" (onClick)="goBack()"></ui-button>
